import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const NotFound = () => {
  return (
    <div className="main-page-wrapper p0">
      <Helmet>
        <title>Not Found || Octy AI</title>
      </Helmet>
      {/* End Page SEO Content */}

      <div className="error-page d-lg-flex align-items-center">
        <div className="img-holder order-lg-last">
          <img
            src="images/media/404.svg"
            alt="man in water with shark"
            className="w-100 illustration"
          />
          <img
            src="images/media/404-q.svg"
            alt="404 not found"
            className="shapes qus"
          />
        </div>
        <div className="text-wrapper order-lg-first">
          <div className="logo">
            <Link to="/">
            <img src="images/logo/text_side_trans@2x.png" alt="Octy AI logo" style={{ height: 80, width: "100%" }}/>
            </Link>
          </div>
          <h1 className="font-source-code-pro">
            Sorry
          </h1>
          <p className="font-source-code-pro">
            but the page you were looking for<br />
            could not be found.
          </p>

          <Link
            to="/"
            className="back-home font-source-code-pro d-flex align-items-center justify-content-center"
          >
            <span>Back to Home</span>
            <img src="images/icon/53.svg" alt="back to home icon" />
          </Link>
        </div>
        {/* /.text-wrapper */}
      </div>
      {/* /.error-page */}
    </div>
  );
};

export default NotFound;
